
import * as React from "react";
import {cx} from "emotion";

import "./slider-1.scss";

import {cs}      from "@Common/react/chain-services";
import {Static2} from "@Common/react/static-2";
import {chain}   from "@Common/utils/fs";

import {Dragging} from "../../dragging";

export const Slider1 = ({state, next}) => cs(
    ["dragging", (_, next) => Dragging({next})],
    ["rangeRef", (_, next) => Static2({next})],
    ["dragValueRef", (_, next) => Static2({next})],

    ["value", ({dragging, dragValueRef}, next) => next(dragging.active?.delta ? dragValueRef.get()(dragging.active?.delta) : state.value)],
    ({dragging, rangeRef, value, dragValueRef}) => next({
        value,
        render: ({direction="horizontal", height=undefined}={}) => {


            const totalAttr = direction==="horizontal" ? "width" : "height";

            return (
                <div {...{
                    className: cx("slider-1-4fk slider", direction),
                    style: {
                        height,
                     },
                    ...dragging.handle,
                }}>
                    <div className="start-tip"/>
                    <div className="end-tip"/>

                    <div className="range" ref={rangeRef.set}>
                        <div
                            className="start-rect"
                            style={{[totalAttr]: `calc(${value * 100}% - 10px)`}}
                        />
                        <div
                            className="end-rect"
                            style={{[totalAttr]: `calc(${(1-value) * 100}% - 10px)`}}
                        />

                        <div
                            className="circle-anchor"
                            style={{
                                [direction === "horizontal" ? "left" : "bottom"]: (value * 100) + "%",
                            }}
                        >
                            <div {...{
                                className: "circle",
                            }}/>

                            {dragging.renderActive({
                                onStart: ({oriPos}) => {
                                    const r = rangeRef.get().getBoundingClientRect();

                                    const translateDelta = (delta) => ensureInBound(
                                        direction==="horizontal" ? (
                                            (oriPos.x + delta.x - r.x) / r[totalAttr]
                                        ) : (
                                            1 - (oriPos.y + delta.y - r.y) / r[totalAttr]
                                        ),
                                        0, 1
                                    );
                                    dragValueRef.set(translateDelta);
                                    state.onChange(translateDelta({x: 0, y: 0}))
                                },
                                onChange: (delta) => state.onChange(dragValueRef.get()(delta)),
                            })}
                        </div>
                    </div>

                </div>
            );
        },
    }),
);

const ensureInBound = (v, from, to) => chain(
    v,
    (_) => Math.max(from, _),
    (_) => Math.min(to  , _),
);

